module.exports = __webpack_public_path__ + "img/電気回路_4_9_1.170954c6.png";